import { ArcBuilderRow } from './arc-builder-row.model';

export class ArcFormula {
  public ArcID: number;
  public Descr: string;
  public ProfileWhere: string;
  public Formula: string;
  public ItemNum: number;
  public Inactive: boolean;
  public Notes: string;
  public ChangedBy: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public ARCBuilderRows: Array<ArcBuilderRow>;

  constructor() {
    this.ArcID = 0;
    this.Descr = '';
    this.ProfileWhere = '';
    this.Formula = '';
    this.ItemNum = 0;
    this.Inactive = false;
    this.Notes = '';
    this.ChangedBy = '';
    this.ARCBuilderRows = new Array<ArcBuilderRow>();
  }
}
